<template>
  <el-tooltip v-bind="$attrs" :effect="effect" :tabindex="-1">
    <template slot="content">
      <slot>{{ content }}</slot>
    </template>
    <i :class="icon || 'el-icon-' + type"></i>
  </el-tooltip>
</template>

<script>
export default {
  name: 'TooltipIcon',
  props: {
    content: String,
    type: {
      type: String,
      default: 'info',
    },
    icon: String,
    effect: {
      type: String,
      default: 'light',
    },
  },
}
</script>
